import { motion, useAnimation } from "framer-motion";
import { useEffect, useState } from "react";

const LineProgress = ({ fillPercent = 70, duration = 1.2 }) => {
  const percent = Math.min(Math.max(fillPercent, 0), 100);
  const controls = useAnimation();
  const [fontSize, setFontSize] = useState(24);

  useEffect(() => {
    controls.start({
      width: `${percent}%`,
      transition: { duration, ease: "easeInOut" },
    });
  }, [percent, controls, duration]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setFontSize(20);
      } else {
        setFontSize(28);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const filledWidth = (1069 * percent) / 100;

  return (
    <div className="relative flex justify-center items-center w-full mt-8 container mx-auto">
      <div className="w-10/12 md:w-11/12 pr-5">
        <svg
          width="100%"
          viewBox="0 0 1069 230"
          preserveAspectRatio="xMidYMid meet"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient
              id="dynamicGradient"
              x1="0"
              y1="0"
              x2={filledWidth}
              y2="0"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0%" stopColor="#5DFF76" />
              <stop offset="100%" stopColor="#54C6F9" />
            </linearGradient>

            <clipPath id="clip">
              <path d="M972.9 17.9C1015.98 17.9 1050.9 52.8218 1050.9 95.9C1050.9 138.978 1015.98 173.9 972.9 173.9C934.601 173.9 902.75 146.297 896.154 109.9H369.646C363.05 146.297 331.199 173.9 292.9 173.9C254.601 173.9 222.75 146.297 216.154 109.9H31.8999C24.1679 109.9 17.8999 103.632 17.8999 95.9C17.8999 88.168 24.1679 81.9 31.8999 81.9H216.154C222.75 45.503 254.601 17.9 292.9 17.9C331.199 17.9 363.05 45.503 369.646 81.9H896.154C902.75 45.503 934.601 17.9 972.9 17.9Z" />
            </clipPath>

            <filter
              id="filter0_d"
              x="0"
              y="0"
              width="1068.8"
              height="191.8"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="8.95" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow"
                result="shape"
              />
            </filter>
          </defs>

          <g filter="url(#filter0_d)">
            <path
              d="M972.9 17.9C1015.98 17.9 1050.9 52.8218 1050.9 95.9C1050.9 138.978 1015.98 173.9 972.9 173.9C934.601 173.9 902.75 146.297 896.154 109.9H369.646C363.05 146.297 331.199 173.9 292.9 173.9C254.601 173.9 222.75 146.297 216.154 109.9H31.8999C24.1679 109.9 17.8999 103.632 17.8999 95.9C17.8999 88.168 24.1679 81.9 31.8999 81.9H216.154C222.75 45.503 254.601 17.9 292.9 17.9C331.199 17.9 363.05 45.503 369.646 81.9H896.154C902.75 45.503 934.601 17.9 972.9 17.9Z"
              fill="white"
            />
          </g>

          <motion.rect
            clipPath="url(#clip)"
            x="0"
            y="0"
            height="192"
            fill="url(#dynamicGradient)"
            animate={controls}
            initial={{ width: "0%" }}
          />

          <image
            href="/images/gift_box2.png"
            x={940}
            y={60}
            width="66"
            height="66"
          />
          <image
            href="/images/gift_box1.png"
            x={236}
            y={40}
            width="111"
            height="111"
          />

          <text
            x={975}
            y={215}
            textAnchor="middle"
            fontSize={fontSize}
            fontFamily="kalameh, sans-serif"
            fill="#000"
          >
            هدیه طلایی
          </text>

          <text
            x={292}
            y={215}
            textAnchor="middle"
            fontSize={fontSize}
            fontFamily="kalameh, sans-serif"
            fill="#000"
          >
            قرعه‌کشی کربلا
          </text>
        </svg>
      </div>
      <div className="w-2/12 md:w-1/12">
        <p className="font-kalameh text-sm sm:text-lg md:text-2xl -mt-4 sm:-mt-5 md:-mt-10">
          شروع کن!
        </p>
      </div>
    </div>
  );
};

export default LineProgress;
